import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../common/auto-form';
import { BeneficiariesEditor } from './beneficiaries-editor';
import { InsuredUniversityResultView } from './result-view';
import { INSURED_UNIVERSITY_FIELDS } from './fields';
import {
  Beneficiary,
  InsuredUniversityFormValues,
  beneficiaryDefaults,
  insuredUniversityDefaults,
  insuredUniversitySchema,
} from './schema';
import { PRODUCT, buildRequestPreview, simulateInsuredUniversity } from './service';

export function InsuredUniversityPage() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);
  const [beneficiaries, setBeneficiaries] = useState<Beneficiary[]>([
    { ...beneficiaryDefaults },
  ]);
  const [beneficiariesError, setBeneficiariesError] = useState<string | undefined>();

  const mutation = useMutation({
    mutationFn: (values: InsuredUniversityFormValues) => (
      simulateInsuredUniversity({ values, beneficiaries })
    ),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card mb-3">
        <div className="card-body">
          <BeneficiariesEditor
            value={beneficiaries}
            onChange={(next) => {
              setBeneficiaries(next);
              if (next.length > 0) setBeneficiariesError(undefined);
            }}
            error={beneficiariesError}
          />
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={INSURED_UNIVERSITY_FIELDS}
            schema={insuredUniversitySchema}
            defaults={insuredUniversityDefaults}
            isLoading={mutation.isLoading}
            expectedProduct={PRODUCT}
            importExtras={[{
              key: 'beneficiaries',
              onImport: (value) => {
                if (!Array.isArray(value)) return;
                setBeneficiaries(value as Beneficiary[]);
                setBeneficiariesError(undefined);
              },
            }]}
            onSubmit={(values) => {
              if (beneficiaries.length === 0) {
                setBeneficiariesError('Agregá al menos un beneficiario.');
                return;
              }
              setLastRequest(buildRequestPreview(values, beneficiaries));
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <InsuredUniversityResultView
          request={lastRequest}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
